import { render, staticRenderFns } from "./NewDashboardUnlockedDialog.vue?vue&type=template&id=58df82fd&scoped=true&"
import script from "./NewDashboardUnlockedDialog.vue?vue&type=script&lang=js&"
export * from "./NewDashboardUnlockedDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewDashboardUnlockedDialog.vue?vue&type=style&index=0&id=58df82fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df82fd",
  null
  
)

export default component.exports